import { useMutation } from 'react-query';
import { ResetPasswordPayload, timefitBackend } from '../../../Shared/Services/TimefitBackend';

export function useResetPassword() {
  const mutation = (payload: ResetPasswordPayload) => {
    return timefitBackend.resetPassword(payload);
  };
  return useMutation(mutation);
}
